import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export  const formatRupees = (value) => {
  const num = Number(value);

  if (isNaN(num)) return 'Invalid number';

  if (num >= 1_00_00_000) {
    return `₹${(num / 1_00_00_000).toFixed(2).replace(/\.00$/, '')} Cr`;
  } else if (num >= 1_00_000) {
    return `₹${(num / 1_00_000).toFixed(2).replace(/\.00$/, '')} Lakh`;
  } else {
    return `₹${num.toLocaleString('en-IN')}`;
  }

  // return `₹${formatted}`;
}

export const MuiLoader = ({ size = 50, message = "" }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 5,
        width: "100%",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress size={size} />
      <p>{message}</p>
    </Box>
  );
};
